import { Link as ReachRouterLink } from '@reach/router';
import styled, { css } from 'styled-components/macro';
import { colourPrimarySeaGreen } from '../styling/colours';
import { getButtonStyles, primaryButtonStyles, secondaryButtonStyles } from './Button';

type Props = {
  to: string;
};

const linkStyles = css`
  color: ${colourPrimarySeaGreen};
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const Link = styled(ReachRouterLink)<Props>`
  ${linkStyles}
`;

export const ExternalLink = styled.a`
  ${linkStyles}
`;

type ButtonLinkProps = Props & {
  rounded?: boolean;
  disabled?: boolean;
};

export const BaseButtonLink = styled(ReachRouterLink)<ButtonLinkProps>`
  ${({ rounded, disabled }) => getButtonStyles(rounded, disabled)};
  text-align: center;
  text-decoration: none;
`;

export const PrimaryButtonLink = styled(BaseButtonLink)<ButtonLinkProps>`
  ${primaryButtonStyles}
`;

export const SecondaryButtonLink = styled(BaseButtonLink)<ButtonLinkProps>`
  ${secondaryButtonStyles}
`;
